// extracted by mini-css-extract-plugin
export default {"container":"ProfileQuestionStartedScreen_container__CLrWR","questionImage":"ProfileQuestionStartedScreen_questionImage__W4BkS"};